import { render, staticRenderFns } from "./ProfileActionInterest.vue?vue&type=template&id=01029563&"
import script from "./ProfileActionInterest.vue?vue&type=script&lang=js&"
export * from "./ProfileActionInterest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports